import languageConfig from '../config/supported_languages';

export function getLanguageDetailsByCode(code) {
    const find = (list, c) => {
        if (!list.length) return false;
        let f = list.splice(0, 1)[0];
        return f.code == c ? f : find(list, c)
    }
    return find(languageConfig.list.slice(), code);
}

export function loadAsset(fileName, fileType) {
    let fileref = null
    let id = fileName.slice().replace(new RegExp('/', 'g'), '_')
    if (fileType === 'js') {
        fileref = document.createElement('script')
        fileref.setAttribute('type', 'text/javascript')
        fileref.setAttribute('src', fileName)
    } else if (fileType === 'css') {
        fileref = document.createElement('link')
        fileref.setAttribute('rel', 'stylesheet')
        fileref.setAttribute('type', 'text/css')
        fileref.setAttribute('href', fileName)
    }



    if (fileref) {
        fileref.id = id;
        if (!document.getElementById(id)) {
            document.getElementsByTagName('head')[0].appendChild(fileref)
        }
    }
}

export function removeAsset(fileName, fileType) {
    let element = null
    let attribute = null

    switch (fileType) {
        case 'js':
            element = 'script'
            attribute = 'src'
            break

        case 'css':
            element = 'link'
            attribute = 'href'
            break

        default:
            element = 'none'
            attribute = 'none'
    }

    const suspects = document.getElementsByTagName(element)

    // we search backwards within nodelist for matching elements to remove
    for (let i = suspects.length; i >= 0; i -= 1) {
        if (suspects[i] &&
            suspects[i].getAttribute(attribute) !== null &&
            suspects[i].getAttribute(attribute).indexOf(fileName) !== -1) {
            suspects[i].parentNode.removeChild(suspects[i])
        }
    }
}


export const loadStyleRTL = () => {
    require('../static/css/custom_rtl.css');
}


export const loadStyleLTR = () => {
    require('../static/css/custom_ltr.css');
}



// WEBPACK FOOTER //
// ./src/helper/asset.js